<template>
  <div
    class="content-cell d-flex"
    :class="{
      'text-center justify-center': align === 'center',
      'text-right justify-end': align === 'end',
    }"
  >
    <component :is="aggregateRenderer" />
  </div>
</template>

<script setup lang="ts">
import { computed, h } from "vue";
import type {
  BmGridColumnConfiguration,
  BmGridSummaryConfiguration,
  ColumnAlignment,
} from "@/components/controls/grid/BmGridData";

/**
 * Thin wrapper around summary.renderer — keeps the CreateElement-based
 * summary API without redesigning it for Vue 3 yet.
 */

interface BmGridAggregateCellProps {
  column: BmGridColumnConfiguration;
  summary: BmGridSummaryConfiguration;
  value: unknown;
  align?: ColumnAlignment;
}

const props = withDefaults(defineProps<BmGridAggregateCellProps>(), {
  align: "start",
});

const aggregateRenderer = computed(() => ({
  name: "BmGridAggregateCellRenderer",
  render: () =>
    props.summary.renderer(
      h,
      props.column.formatter(props.value, undefined),
      undefined,
      props.summary
    ),
}));
</script>

<style scoped lang="sass">
.content-cell
  padding: 8px
  overflow: hidden
  text-overflow: ellipsis
</style>
